/**
 * Make focusNext global function available as method on all components.
 */

export default {
	methods: {
		focusNext(options) {
			window.focusNext(options);
		}
	}
};